
const listErrorType = [
	{ key: 0, message: 'contient une iFrame' },
	{ key: 1, message: 'applique un style sur le body' },
	{ key: 2, message: 'n\'est pas un Xml valide' },
	{ key: 3, message: 'n\'est pas un LIQUID valide' },
];
export default listErrorType;